import { useState } from "react";
import { useMyInfoChg } from "../authentication/useMyInfoChg";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "@/comn/components";
import { useTheme } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";

const FindId = ({
    embedded = false,
    onFindPassword,
}: {
    embedded?: boolean;
    onFindPassword?: (usrId: string) => void;
}) => {
    const imgs = { imgId: `${process.env.PUBLIC_URL}/imgs/img-id.png` };
    const { theme } = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { findIdForm, setFindIdForm, handleSubmitFindId } = useMyInfoChg();

    const { usrId, usrNm, usrEmlAddr, cstmOfcrNo, isLcm } = findIdForm;

    return (
        <div className="w-full flex justify-center relative">
            <div className="w-full flex justify-center mt-[70px]">
                <div className={classNames("find-content-min w-full md:w-[520px] lg:w-[520px] h-auto relative")}>
                    <img
                        src={imgs["imgId"]}
                        width={"700px"}
                        height={"auto"}
                        className="grayscale opacity-10 absolute top-[100px] -left-[300px] -z-[1] hidden md:block lg:block"
                    />
                    {/*<div className="find-header bg-primary p-[30px] relative rounded-t-[30px]">*/}
                    {/*    <h2 className="text-2xl text-white">{t("L_FIND_ID")}</h2>*/}
                    {/*    <span className="block w-[180px] lg:w-[236px] absolute -top-[84px] -right-[10px] lg:-right-[80px]">*/}
                    {/*        /!*<img src={imgs["imgId"]} width={"100%"} height={"auto"} className="" alt="" />*!/*/}
                    {/*    </span>*/}
                    {/*</div>*/}

                    {comnUtils.isEmpty(usrId) ? (
                        <form
                            className={classNames(
                                "find-body p-[40px] flex flex-col gap-[70px]",
                                embedded ? "pt-[40px]" : "rounded-b-[30px] pt-[70px] bg-card shadow-lg",
                            )}
                            onSubmit={handleSubmitFindId}
                        >
                            <div className="find-body-min flex flex-col gap-[14px]">
                                {process.env.REACT_APP_SYSTEM_GROUP == "tanesw" && (
                                    <div className="h-12 rounded border border-blue flex items-center px-[16px] gap-[5px] text-blue">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input
                                                hidden
                                                className="peer"
                                                type="checkbox"
                                                checked={isLcm}
                                                onChange={(event) =>
                                                    setFindIdForm((prev) => ({ ...prev, isLcm: event.target.checked }))
                                                }
                                            />
                                            <div className="border rounded-full border-blue w-4 h-4 flex items-center justify-center [&_*]:peer-checked:block">
                                                <Icon className="hidden" icon="check" size="xs" />
                                            </div>
                                            License applicants, please select.
                                        </label>
                                    </div>
                                )}
                                <p className="flex gap-[5px]">
                                    {!isLcm ? (
                                        <>
                                            <label htmlFor="usrNm" className="block w-[100px] text-sm pt-[8px]">
                                                {t("L_NAME")}
                                            </label>
                                            <span className="flex flex-col gap-[4px] w-full">
                                                <input
                                                    type="text"
                                                    className="text-sm input bg-transparent h-[36px] w-full"
                                                    value={usrNm}
                                                    onChange={(event) =>
                                                        setFindIdForm((prev) => ({
                                                            ...prev,
                                                            usrNm: event.target.value,
                                                        }))
                                                    }
                                                />
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <label htmlFor="usrNm" className="block w-[100px] text-sm pt-[8px]">
                                                {t("L_CO_NM")}
                                            </label>
                                            <span className="flex flex-col gap-[4px] w-full">
                                                <input
                                                    type="text"
                                                    className="text-sm input bg-transparent h-[36px] w-full"
                                                    value={usrNm}
                                                    onChange={(event) =>
                                                        setFindIdForm((prev) => ({
                                                            ...prev,
                                                            usrNm: event.target.value,
                                                        }))
                                                    }
                                                />
                                            </span>
                                        </>
                                    )}
                                </p>
                                <p className="flex gap-[5px]">
                                    <label htmlFor="usrEmlAddr" className="block w-[100px] text-sm pt-[8px]">
                                        {t("L_EML")}
                                    </label>
                                    <span className="flex flex-col gap-[4px] w-full">
                                        <input
                                            type="text"
                                            className="text-sm input bg-transparent h-[36px] w-full"
                                            value={usrEmlAddr}
                                            onChange={(event) =>
                                                setFindIdForm((prev) => ({
                                                    ...prev,
                                                    usrEmlAddr: event.target.value,
                                                }))
                                            }
                                        />
                                    </span>
                                </p>
                                {/*<p>*/}
                                {/*    <Button*/}
                                {/*        color={theme.isDark == "true" ? "white" : "black"}*/}
                                {/*        variant="underlined"*/}
                                {/*        width="full"*/}
                                {/*        onClick={() => navigate("/findPassword")}*/}
                                {/*    >*/}
                                {/*        Find Password*/}
                                {/*    </Button>*/}
                                {/*</p>*/}
                            </div>

                            <button
                                type="submit"
                                className={classNames(
                                    "w-full rounded-[32px] h-[60px] text-base bg-primary-fill-5 border border-primary text-primary dark:text-white dark:border-white dark:hover:border-primary",
                                    "hover:bg-primary hover:text-white hover:border-primary",
                                )}
                            >
                                {t("L_FIND_ID")}
                            </button>
                        </form>
                    ) : (
                        <div className="find-body rounded-b-[30px] p-[40px] pt-[70px] bg-card flex flex-col gap-[70px] shadow-lg">
                            <div className="find-body-min flex flex-col gap-[14px] items-center justify-center">
                                <p className="w-full text-center text-sm">{t("msg.osc.00116")}</p>
                                <p className="w-full bg-background p-[20px] text-center text-sm">
                                    <input
                                        type="text"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={usrId}
                                        readOnly
                                    />
                                </p>
                            </div>

                            {!embedded && (
                                <div className="flex gap-[10px]">
                                    <button
                                        className={classNames(
                                            "w-full rounded-[32px] h-[60px] text-base bg-primary-fill-5 border border-primary text-primary dark:text-white dark:border-white dark:hover:border-primary",
                                            "hover:bg-primary hover:text-white hover:border-primary",
                                        )}
                                        onClick={() => {
                                            if (!usrId) return;
                                            if (onFindPassword) {
                                                onFindPassword(usrId);
                                            } else {
                                                navigate("/findPassword", { state: { usrId } });
                                            }
                                        }}
                                    >
                                        {t("L_FIND_PWD")}
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FindId;
